"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functions = require("../utils/functions");

var _constants = require("../utils/constants");

var _default = function _default() {
  var clientId = (0, _functions.getCookie)(_constants.CLIENT_ID_COOKIE_NAME);

  if (document.cookie && clientId) {
    return {
      id: 'loginReducer',
      clientId: clientId,
      login: _constants.LOGADO
    };
  }

  return {
    id: 'loginReducer',
    login: _constants.NO_LOGADO
  };
};

exports["default"] = _default;